import type { FaireProductEntity } from "../../entity_types/product";

export const p_erbcktg8dq: FaireProductEntity = {
  token: "p_erbcktg8dq",
  type: "product",
  name: '2" TOY FILLED EASTER EGG (24PCS/UNIT)',
  brandToken: "b_956wcc3gjb",
  brandName: "The Toy Network",
  imageUrl:
    "https://cdn.faire.com/fastly/8642e34178917ff349564963a889605acfa1b71deb8eaf2172c814d1926faec8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6f6d2900ab3bcca20c6112fb139cdb9f75f8e841351c084ba34cf8f513ef222.png",
  ],
  priceDollars: 0.35,
  description:
    "These toy-filled easter eggs are for Easter gifts and baskets. Sold by the unit. 24 pieces per unit.",
  tags: [],
  msrpDollars: 0.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:46.214Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
